import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCopy = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="currentColor"><path d="M20.593 5.597H5.716a2.53 2.53 0 0 0-2.528 2.528v21.347A2.53 2.53 0 0 0 5.716 32h14.877a2.53 2.53 0 0 0 2.528-2.528V8.125a2.536 2.536 0 0 0-2.528-2.528zm.753 23.868c0 .42-.34.76-.76.76H5.71a.76.76 0 0 1-.76-.76V8.125c0-.42.34-.76.76-.76h14.877c.42 0 .76.34.76.76z" /><path d="M26.284 0h-14.88a2.53 2.53 0 0 0-2.529 2.528c0 .492.395.886.886.886a.883.883 0 0 0 .886-.886c0-.42.34-.76.76-.76h14.877c.42 0 .76.34.76.76v21.347c0 .42-.34.76-.76.76a.883.883 0 0 0-.886.885c0 .492.394.886.885.886a2.53 2.53 0 0 0 2.529-2.528V2.528A2.532 2.532 0 0 0 26.283 0z" /></g></svg>;
export default SvgCopy;